export const HTTP_REQUEST_TIMEOUT_MS = 30000;
export const WS_CLIENT_NAME = "RAKDEDTester";
export const WS_PASSWORD = "d41d8cd98f00b204e9800998ecf8427e";
export const REST_CLIENT_NAME = "apiuser2";
export const REST_PASSWORD = "cc6063d42c4ac91e326c2abcb05eb69040f44702a067645fe623811b478b9bb4";
export const MIN_ALLOW_APPOINTMENT_PERIOD_MIN = 120;
export const SESSION_EXPIRY_MIN = 6;
export const SESSION_EXPIRY_POPUP_SEC = 60;
